import { signInWithPopup, GoogleAuthProvider, getAdditionalUserInfo, Auth, AuthError } from "firebase/auth";
import Navbar from "../components/nav/Navbar";
import {Button} from "@mui/material";
import {useState} from "react";
import {Session} from "./session";
import {Navigate, redirect, useNavigate} from "react-router";
import {Footer} from "../components/Footer";

interface Props {
    auth: Auth
    session: Session | null
    doAuth: () => void
}

export function Authentication({auth, session, doAuth}: Props) {
    const [error, setError] = useState<string>("");

    if (session) {
        return <Navigate to="/my-wayfare" replace={true} />
    }

    return <div id="app-root">
        <Navbar />
        <div className="document">
            {error ? <div className="alert alert-danger">{error}</div> : null}
            <div className="text-center p-4">Login with Google below to start your Wayfare:</div>
            <div className="text-center p-4">
                <Button onClick={doAuth}>Sign in with Google &raquo;</Button>
            </div>
        </div>
        <Footer />
    </div>
}
